import {
    DEBLJINE_LIM,
    DOP_CONFIG, IZVOR_MEHANICKI_SVOJSTAVA,
    OTPORNOST, PROIZVODJACI,
    STANDARD_OPTIONS,
    USKLADJENI_STANDARDI
} from '../config/dopConfig'

import KvalitetMaterijalaDropdown from "../../../../components/KvalitetMaterijalaDropdown/KvalitetMaterijalaDropdown"
import React, { useEffect } from "react"

const Step2Zaglavlje = ({ formData, setFormData }: any) => {

    const update = (section: string, field: string, value: any) => {
        setFormData((prev: any) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }))
    }

    const updateRoot = (field: string, value: any) => {
        setFormData((prev: any) => ({
            ...prev,
            [field]: value
        }))
    }

    const is14509 = formData.standard === 'EN_14509_2014'
    const is13165 = formData.standard === 'EN_13165_2017'

    useEffect(() => {
        if (is13165) {
            update(
                'zaglavlje',
                'podrucjePrimjene',
                'Termoizolacione ploče za upotrebu u građevinarstvu - Izolacija podova, zidova, krovova'
            );

            return;
        }

        if (is14509) {
            const vrstaProizvoda = formData?.zaglavlje?.vrstaProizvoda || '';

            let podrucjePrimjene =
                'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Zidovi i oblaganje zidova';

            if (vrstaProizvoda === 'KP') {
                podrucjePrimjene =
                    'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Krovovi i oblaganje krovova';
            } else if (vrstaProizvoda.startsWith('ZP')) {
                podrucjePrimjene =
                    'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Zidovi i oblaganje zidova';
            } else if (vrstaProizvoda.startsWith('FPP')) {
                podrucjePrimjene =
                    'Metalom obložen termoizolacioni panel za upotrebu u građevinarstvu - Hladionički panel';
            }

            update(
                'zaglavlje',
                'podrucjePrimjene',
                podrucjePrimjene
            );
        }
    }, [
        formData.standard,
        formData?.zaglavlje?.vrstaProizvoda
    ]);

    const reakcija = formData.reakcijaNaVatru || {}
    const otpornost = formData.otpornostNaVatru || {}
    const zaglavlje = formData.zaglavlje || {}
    const materijal = formData.materijal || {}

    // IDENTIFIER
    const oznaka = [
        'TOPTERM',
        zaglavlje.vrstaProizvoda,
        zaglavlje.vrstaIspune
    ].filter(Boolean).join('-')

    // LABELS
    const reakcijaLabel = [
        reakcija.performance,
        reakcija.smoke ? `-${reakcija.smoke}` : '',
        reakcija.droplets ? `, ${reakcija.droplets}` : ''
    ].filter(Boolean).join('')

    const otpornostLabel =
        otpornost.enabled === 'Da'
            ? [otpornost.type, otpornost.minutes && `${otpornost.minutes}`]
                .filter(Boolean)
                .join(' ')
            : otpornost.enabled === 'Ne'
                ? 'Nije deklarisano'
                : ''

    return (
        <div className="row g-5">

            <h4>Zaglavlje dokumenta</h4>

            {/* IDENTIFIKACIJA */}
            <div className="col-12">
                <label>Jedinstvena identifikacijska oznaka</label>
                <input className="form-control" value={oznaka || ''} readOnly />
            </div>

            {/* VRSTA PROIZVODA */}
            <div className="col-md-6">
                Vrsta proizvoda <span className="text-danger">*</span>
                <select
                    required
                    className="form-select"
                    value={zaglavlje.vrstaProizvoda || ''}
                    onChange={(e) => update('zaglavlje', 'vrstaProizvoda', e.target.value)}
                >
                    <option value="">-- Odaberi --</option>
                    {['KP','ZPS1','ZPS2','ZPV1','ZPV2','FPP', 'ThermoBoard'].map(v => (
                        <option key={v} value={v}>{v}</option>
                    ))}
                </select>
            </div>

            {/* VRSTA ISPUNE */}
            <div className="col-md-6">
                <label>Vrsta ispune</label>
                <select
                    className="form-select"
                    value={zaglavlje.vrstaIspune || ''}
                    onChange={(e) => update('zaglavlje', 'vrstaIspune', e.target.value)}
                >
                    <option value="">-- Odaberi --</option>
                    {['PUR','PIR','RW'].map(v => (
                        <option key={v} value={v}>{v}</option>
                    ))}
                </select>
            </div>

            {/* PODRUČJE */}
            <div className="col-md-12">
                <label>Područje primjene</label>
                <input
                    className="form-control"
                    value={zaglavlje.podrucjePrimjene || ''}
                    onChange={(e) => update('zaglavlje', 'podrucjePrimjene', e.target.value)}
                />
            </div>

            {/* STATIC */}
            <div className="col-md-12">
                <label>Proizvođač</label>
                <select
                    className="form-select"
                    value={zaglavlje.proizvodjac || ''}
                    onChange={(e) =>
                        update(
                            'zaglavlje',
                            'proizvodjac',
                            e.target.value
                        )
                    }
                >
                    <option value="">-- Odaberi --</option>

                    {PROIZVODJACI.map((p) => (
                        <option key={p.value} value={p.value}>
                            {p.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="col-md-6">
                <label>Ovlašteni zastupnik</label>
                <input className="form-control" value="/" readOnly />
            </div>

            {/* SISTEM */}
            <div className="col-md-6">
                <label>Sistem</label>
                <select
                    className="form-select"
                    value={zaglavlje.sistem || ''}
                    onChange={(e) => update('zaglavlje', 'sistem', e.target.value)}
                >
                    <option value="">-- Odaberi --</option>
                    {['Sistem 1','Sistem 2+','Sistem 3','Sistem 4'].map(v => (
                        <option key={v} value={v}>{v}</option>
                    ))}
                </select>
            </div>

            {/* STANDARD */}
            <div className="col-md-6">
                <label>Usklađeni standard</label>
                <select
                    className="form-select"
                    value={zaglavlje.uskladjeniStandard || ''}
                    onChange={(e) => update('zaglavlje','uskladjeniStandard',e.target.value)}
                >
                    <option value="">-- Odaberi --</option>
                    {USKLADJENI_STANDARDI.map(s => (
                        <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                </select>
            </div>

            {/* NOTIFIED */}
            <div className="col-md-6">
                <label>Obavještajno tijelo</label>
                <select
                    className="form-select"
                    value={zaglavlje.notifiedBody || ''}
                    onChange={(e) => update('zaglavlje','notifiedBody',e.target.value)}
                >
                    <option value="">-- Odaberi --</option>
                    {DOP_CONFIG.notifiedBodies.map(n => (
                        <option key={n} value={n}>{n}</option>
                    ))}
                </select>
            </div>

            {/* DOKUMENT */}
            <div className="col-md-6">
                <label>Dokument o Europskom tehničkom ocjenjivanju</label>
                <select
                    className="form-select"
                    value={zaglavlje.dokument || ''}
                    onChange={(e) => update('zaglavlje','dokument',e.target.value)}
                >
                    <option value="nije_relevantno">Nije relevantno</option>
                </select>
            </div>

            {/* ======================= */}
            {/* 14509 */}
            {/* ======================= */}
            {is14509 && (
                <>
                    <div className="col-12 mt-5">
                        <h5>Reakcija na vatru</h5>
                        {reakcijaLabel && <div className="text-muted">{reakcijaLabel}</div>}
                    </div>

                    <div className="col-md-3">
                        <select className="form-select"
                                value={reakcija.performance || ''}
                                onChange={(e)=>update('reakcijaNaVatru','performance',e.target.value)}>
                            <option value="">Klasa</option>
                            {DOP_CONFIG.performanceClass.map(v => <option key={v}>{v}</option>)}
                        </select>
                    </div>

                    <div className="col-md-3">
                        <select className="form-select"
                                value={reakcija.smoke || ''}
                                onChange={(e)=>update('reakcijaNaVatru','smoke',e.target.value)}>
                            {DOP_CONFIG.smoke.map(v => <option key={v}>{v}</option>)}
                        </select>
                    </div>

                    <div className="col-md-3">
                        <select className="form-select"
                                value={reakcija.droplets || ''}
                                onChange={(e)=>update('reakcijaNaVatru','droplets',e.target.value)}>
                            {DOP_CONFIG.droplets.map(v => <option key={v}>{v}</option>)}
                        </select>
                    </div>

                    <div className="col-md-3">
                        <select className="form-select"
                                value={reakcija.standard || ''}
                                onChange={(e)=>update('reakcijaNaVatru','standard',e.target.value)}>
                            {STANDARD_OPTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                        </select>
                    </div>

                    {/* OTPORNOST */}
                    <div className="col-12 mt-5">
                        <h5>Otpornost na vatru</h5>
                        {otpornostLabel && <div className="text-muted">{otpornostLabel}</div>}
                    </div>

                    <div className="col-md-3">
                        <select className="form-select"
                                value={otpornost.enabled || ''}
                                onChange={(e)=>update('otpornostNaVatru','enabled',e.target.value)}>
                            <option value="">--</option>
                            {OTPORNOST.enabled.map(v => <option key={v}>{v}</option>)}
                        </select>
                    </div>

                    {otpornost.enabled === 'Da' && (
                        <>
                            <div className="col-md-3">
                                <select className="form-select"
                                        value={otpornost.type || ''}
                                        onChange={(e)=>update('otpornostNaVatru','type',e.target.value)}>
                                    {OTPORNOST.type.map(v => <option key={v}>{v}</option>)}
                                </select>
                            </div>

                            <div className="col-md-3">
                                <select className="form-select"
                                        value={otpornost.minutes || ''}
                                        onChange={(e)=>update('otpornostNaVatru','minutes',e.target.value)}>
                                    {OTPORNOST.minutes.map(v => <option key={v}>{v}</option>)}
                                </select>
                            </div>

                            <div className="col-md-3">
                                <select className="form-select"
                                        value={otpornost.standard || ''}
                                        onChange={(e)=>update('otpornostNaVatru','standard',e.target.value)}>
                                    {STANDARD_OPTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                                </select>
                            </div>
                        </>
                    )}
                </>
            )}

            {/* ======================= */}
            {/* 13165 */}
            {/* ======================= */}
            {is13165 && (
                <>
                    <div className="col-md-6">
                        <label>Izolacija</label>
                        <select className="form-select"
                                value={formData.izolacija || ''}
                                onChange={(e)=>updateRoot('izolacija',e.target.value)}>
                            <option value="">-- Odaberi --</option>
                            {DOP_CONFIG.izolacija.map(i => (
                                <option key={i.value} value={i.value}>{i.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-6">
                        Kvalitet materijala <span className="text-danger">*</span>
                        <KvalitetMaterijalaDropdown
                            value={materijal.liceKvalitetId}
                            onChange={(n,v)=>update('materijal','liceKvalitetId',v)}
                            selectName="liceKvalitet"
                        />
                    </div>
                </>
            )}

            {/* ======================= */}
            {/* MATERIJAL 14509 */}
            {/* ======================= */}
            {is14509 && (
                <>
                    <div className="col-12 mt-5">
                        <h5>Materijal</h5>
                    </div>

                    <div className="col-md-4">
                        <label>Standard</label>
                        <select
                            className="form-select"
                            value={materijal.standard || ''}
                            onChange={(e)=>update('materijal','standard',e.target.value)}
                        >
                            {STANDARD_OPTIONS.map(s => (
                                <option key={s.value} value={s.value}>{s.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-4">
                        Kvalitet materijala lice
                        <span className="text-danger">*</span>
                        <KvalitetMaterijalaDropdown
                            value={materijal.liceKvalitetId}
                            onChange={(n,v)=>update('materijal','liceKvalitetId',v)}
                            selectName="liceKvalitet"
                        />
                    </div>
                    <div className="col-md-4">
                        Kvalitet materijala nalicje
                        <span className="text-danger">*</span>
                        <KvalitetMaterijalaDropdown
                            value={materijal.nalicjeKvalitetId}
                            onChange={(n,v)=>update('materijal','nalicjeKvalitetId',v)}
                            selectName="nalicjeKvalitet"
                        />
                    </div>
                </>
            )}
            <div className='row'>
                <div className="col-md-6">
                    <div className="col-12 mt-5">
                        <h5>Izvor mehaničkih svojstava</h5>
                    </div>
                    <select
                        className="form-select"
                        value={zaglavlje.izvorMehanickihSvojstava  || ''}
                        onChange={(e) =>
                            update(
                                'zaglavlje',
                                'izvorMehanickihSvojstava',
                                e.target.value
                            )
                        }
                    >
                        <option value="">-- Odaberi --</option>

                        {IZVOR_MEHANICKI_SVOJSTAVA.map((p) => (
                            <option key={p.value} value={p.value}>
                                {p.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    )
}

export default Step2Zaglavlje